const COLORS = {
	WHITE: "#FFFFFF",
	WHITESMOKE: "#F1F1F1",
	WHITESMOG: "#F2F2F2",
	BLACK: "#000000",
	DARKGRAYBLUE: "#333545",
	MEDIUMGRAY: "#333333",
	DARKGRAY: "#555555",
	DIMGRAY: "#666666",
	DARKESTGRAY: "#999999",
	NAVGRAY: "#ACACAC",
	LINKGRAY: "#AAABAC",
	LIGHTGRAY: "#CCCCCC",
	LIGHTESTGRAY: "#DDDDDD",
	GRAY: "#A7A7A7",
	BMSRED: "#E8135D",
	ERRORRED: "#a94442",
	SUCCESSGREEN: "#00be78",
	BLUE: "#0078FF",
	AMARNATH: "#E7364D",
	COLDRED: "#B50000",
	COOLBLUE: "#3E6EEA",
	WILDSAND: "#f5f5f5",
	RADIANTBLUE: "#0378FF",
	TUNA: "#333545",
	NERO: "#1B1B1B",
	EBONYCLAY: "#1F2533",
	SEIS: "#EEEEEE",
	ZAMBEZI: "#595959",
	MARINER: "#3B57A1",
	WHISPER: "#EBEBEB",
	TORYBLUE: "#344D8E",
	CINCO: "#CCCCCC",
	TRECE: "#FFCB01",
	SELECTIONYELLOW: "#EDEDED80",
	WHISP: "#E5E5E5",
	LIGHTRADIANTBLUE: "#4d9eff",
	LINKBLUE: "#3390FF",
	FOOTERGRAY: "#7f7f7f",
	FOOTERDARKGRAY: "#313035",
	FOOTERHEADERGRAY: "#a5a5a5",
	FOOTERLIGHTGRAY: "#333338",
	FOOTERGRAY1: "#eaeaea",
	NOTIFICATIONBG: "#f5f5fa",
	NOTIFICATIONTITLE: "#4cd9aa",
	NAVYBLUE: "#2e3147",
	DARKBLUE: "#222539",
	LIGHTRED: "#e7374d",
	PLACEHOLDER_BLUE: "#3b3e58",
	BMS_RED_1: "#DC3558",
	BMS_RED_2: "#F84464",
	INFO_3: "#FFF3D2",
	TRANSPARENT_DARK: "rgba(34, 34, 34, 0.8)",
};

export default COLORS;
